// Checkout networking is loaded only when the cart is used.
let loadedActions
const actions = Object.fromEntries([
  'AddProductToCart', 'DecrementProductFromCart', 'DeleteItemFromCart',
  'AddCourseToCart', 'refreshCourseCart', 'DeleteCourseFromCart',
  'refreshActiveOrderState', 'syncCartOrder', 'syncCartOrderAfterLogin',
  'fetchDiscountAmount', 'fetchCreateOrder'
].map(name => [name, (...args) => {
  if (loadedActions) return loadedActions[name](...args)
  return import(/* webpackChunkName: "shop-actions" */ './actions.js').then(module => {
    loadedActions = module.default
    return loadedActions[name](...args)
  })
}]))

export const shop = {
  namespaced: true,
  state: {
    cart: [],
    discount_amount: 0,
    fixed_discount: 0,
    discount_rules: null,
    promocode: '',
    new_order: '',
    active_order_id: null
  },
  // computed
  getters: {
    cartProducts (state, getters, rootState, rootGetters) {
      const catalogProducts = Array.isArray(rootState?.catalog?.products)
        ? rootState.catalog.products
        : []

      return state.cart.reduce((items, cartItem) => {
        if (cartItem.kind === 'course') {
          items.push({ ...cartItem, quantity: 1, mass: 0 })
          return items
        }
        const product = catalogProducts.find(product => product.id === cartItem.id)
        if (!product) {
          return items
        }
        items.push({
          id: product.id,
          slug: product.slug,
          category: product.category,
          category_slug: product.category_slug,
          title: product.name,
          price: product.price,
          photo: product.photo,
          photo_variants: product.photo_variants,
          mass: product.mass,
          quantity: cartItem.quantity
        })
        return items
      }, [])
    },
    getDeliveryPrice (state, getters, rootState, rootGetters) {
      if (!getters.cartHasProducts) {
        return 0
      }
      if (rootState.delivery.delivery_price.price) {
        return (rootState.delivery.delivery_price.price + ' ₽')
      } else {
        return 0
      }
    },
    getDiscountAmount (state, getters) {
      return state.discount_amount
    },
    cartProductTotal (state, getters) {
      return (thisproduct) => {
        const cartProduct = getters.cartProducts.find(product => product.id === thisproduct.id)
        if (!cartProduct) {
          return 0
        }
        return cartProduct.price * cartProduct.quantity
      }
    },
    cartTotal (state, getters) {
      let total = 0

      getters.cartProducts.forEach(product => {
        total += product.price * product.quantity
      })

      return total
    },
    cartTotalWeight (state, getters) {
      let total = 0

      getters.cartProducts.forEach(product => {
        total += product.mass * product.quantity
      })

      return total / 1000
    },
    productIsInStock () {
      return (product) => {
        return product.stock > 0
      }
    },
    getCurrentProduct (state, getters, rootState, rootGetters) {
      return (product) => {
        return rootState.catalog.products.find(item => item.id === product.id)
      }
    },
    getCurrentCartProductQuantity (state, getters, rootState, rootGetters) {
      return (product) => {
        const cartProduct = state.cart.find(item => item.id === product.id)
        if (cartProduct) {
          return state.cart.find(item => item.id === product.id).quantity
        } else {
          return 0
        }
      }
    },
    cartHasProducts (state) {
      return state.cart.some(item => item.kind !== 'course')
    }
  },
  // methods
  actions,
  mutations: {

    initialiseCart (state) {
      if (localStorage.getItem('cart')) {
        state.cart = JSON.parse(localStorage.getItem('cart')) || []
      }
      localStorage.removeItem('course_cart')
      const rawOrderId = localStorage.getItem('shop_active_order_id')
      const parsedOrderId = Number(rawOrderId)
      state.active_order_id = Number.isFinite(parsedOrderId) && parsedOrderId > 0 ? parsedOrderId : null
    },
    setCourseCartItem (state, item) {
      const index = state.cart.findIndex(x => x.id === item.id)
      if (index < 0) state.cart.push(item)
      else state.cart.splice(index, 1, item)
      localStorage.setItem('cart', JSON.stringify(state.cart))
    },
    pushProductToCart (state, productId) {
      // const item = {
      //     'id': productId,
      //     'quantity': 1
      // }

      state.cart.push({
        id: productId,
        quantity: 1
      })

      localStorage.setItem('cart', JSON.stringify(state.cart))
    },
    incrementItemQuantity (state, cartItem) {
      cartItem.quantity++
      localStorage.setItem('cart', JSON.stringify(state.cart))
    },
    decrementItemQuantity (state, cartItem) {
      cartItem.quantity--
      localStorage.setItem('cart', JSON.stringify(state.cart))
    },
    deleteItemFromCart (state, cartItem) {
      console.log('deleteItemFromCart')
      // cartItem.quantity--
      const index = state.cart.indexOf(cartItem)
      state.cart.splice(index, 1)
      localStorage.setItem('cart', JSON.stringify(state.cart))
    },
    setDiscountAmount (state, discountAmount) {
      state.discount_amount = Number(discountAmount?.percent ?? discountAmount) || 0
      state.fixed_discount = Number(discountAmount?.fixed_discount) || 0
      state.discount_rules = discountAmount?.scope ? discountAmount : null
    },
    setPromocode (state, promocode) {
      state.promocode = promocode
    },
    setNewOrder (state, newOrder) {
      state.new_order = newOrder
    },
    setActiveOrderId (state, orderId) {
      const parsed = Number(orderId)
      const normalized = Number.isFinite(parsed) && parsed > 0 ? parsed : null
      state.active_order_id = normalized
      if (normalized) {
        localStorage.setItem('shop_active_order_id', String(normalized))
      } else {
        localStorage.removeItem('shop_active_order_id')
      }
    },
    clearCartState (state) {
      state.cart = []
      state.discount_amount = 0
      state.fixed_discount = 0
      state.discount_rules = null
      state.promocode = ''
      state.new_order = ''
      state.active_order_id = null
      localStorage.removeItem('cart')
      localStorage.removeItem('course_cart')
      localStorage.removeItem('shop_active_order_id')
    }
  }
}
